import React, { Component } from 'react';
import './styles.css';

class Content extends Component {
  render(){
    return (
      <main>
        {this.props.children}
      </main>
    );
  }
}

export default Content;



// WEBPACK FOOTER //
// ./src/components/Content/Content.js